// import Rule from './Rule';
/**
 * Classe Validation
 * Serve per validare un insieme di fields
 */
class Validation {
    /**
     * Setta le regole `rules` ai campi `fields`
     * @constructor
     * @param {Object} rules 
     * @param {Array.<HTMLElement>} fields 
     */
    constructor(rules = {}, fields = []) {
        this.rules = {};
        this.setFields(fields);
        for(let field of this.fields) {
            this.setRules(field.name, rules[field.name]);
        }
    }

    /**
     * Setta i field da validare
     * @param {Array.<HTMLElement>} fields 
     */
    setFields(fields = []) {
        this.fields = fields;
    }

    /**
     * Setta le regola relative al field di nome `fieldName`
     * @param {string} fieldName 
     * @param {Object} rules 
     */
    setRules(fieldName, rules = {}) {
        this.rules[fieldName] = new Rule(rules);
    }

    /**
     * Restituisce i fields
     * @return {Array.<HTMLElement>}
     */
    getFields() {
        return this.fields;
    }

    /**
     * Restituisce il field di nome `fieldName`
     * @param {string} fieldName
     * @return {HTMLElement}
     */
    getField(fieldName) {
        return this.fields.find(field => field.name === fieldName);
    }

    /**
     * Restituisce le regole relative al field di nome `fieldName`
     * @param {string} fieldName
     * @return {Rule}
     */
    getRules(fieldName) {
        return this.rules[fieldName] || null; 
    }

    /**
     * Restituisce gli eventuali errori se il field di nome `fieldName` è invalido
     * @param {string} fieldName
     * @return {Array.<string>}
     */
    validateField(fieldName) {
        const field = this.getField(fieldName);
        const rule = this.getRules(fieldName);
        return rule.apply(field.value);
    }

    /**
     * Restituisce gli eventiali errori dei campi in un oggetto della forma {..., `fieldName`: [`errors`], ....}
     * @return {Object} Gli errori
     */
    validate() {
        let errors = {};
        for(let field of this.fields) {
            const name = field.name;
            let fieldErrors = this.validateField(name);
            if(fieldErrors.length > 0) {
                errors[name] = fieldErrors;
            }
        }
        return errors;
    }
}